import {
  Box,
  CssBaseline,
  ThemeProvider,
  CircularProgress,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import RoutesTwo from "./routes/Routes";
import { useLocation } from "react-router";
import { fetchData } from "./views/utilities/api";
import { SnackBarProvider } from "./context/SnackBarContext";
import { baselightTheme } from "./theme/DefaultColors";
import "./App.css";
import { Provider } from "react-redux";
import store from "./redux/store";
import axios from "axios";
import { baseUrl, redirectUrl } from "./config";
import SessionExpire from "./components/SessionExpiry";

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 440) {
      window.dispatchEvent(new Event("session-expired"));
      return new Promise(() => {});
    }
    return Promise.reject(error);
  }
);

function App() {
  const theme = baselightTheme;

  const location = useLocation();

  // Get the current URL
  const params = location.search;

  let ur_d = params?.slice(8);
  if (ur_d) {
    localStorage.setItem("lgpath", ur_d);
  }

  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleSessionExpired = () => {
      setOpen(true);
      setTimeout(() => {
        window.location.href = redirectUrl;
      }, 3000);
    };

    window.addEventListener("session-expired", handleSessionExpired);
    checkSession();

    return () => {
      window.removeEventListener("session-expired", handleSessionExpired);
    };
  }, []);

  const checkSession = async () => {
    try {
      const res = await axios.get(baseUrl + "/validateSession", {
        withCredentials: true,
      });
      console.log(res?.data);
    } catch (error) {
      if (error.response?.status === 440) {
        setOpen(true);

        setTimeout(() => {
          window.location.href = redirectUrl;
        }, 3000);
      }
    }
  };

  useEffect(() => {
    const checkModules = async () => {
      const data = await fetchData("/api/checkLaundry");
      if (data?.data?.isLaundry === "YES") {
        localStorage.setItem("isLaundry", true);
      } else {
        localStorage.setItem("isLaundry", false);
      }

      if (data?.data?.isCarWash === "YES") {
        localStorage.setItem("isCarWash", true);
      } else {
        localStorage.setItem("isCarWash", false);
      }
      // Set loading to false after the API call completes
      setLoading(false);
    };

    checkModules();
  }, []);

  return (
    <Box sx={{ background: "#edeff6" }}>
      <SnackBarProvider>
        <Provider store={store}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            {open ? (
              <SessionExpire open={open} />
            ) : loading ? (
              <CircularProgress
                sx={{ display: "block", margin: "auto", marginTop: "20%" }}
              />
            ) : (
              <RoutesTwo />
            )}
          </ThemeProvider>
        </Provider>
      </SnackBarProvider>
    </Box>
  );
}

export default App;
